import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiArrowLeft, FiFileText,
  FiClock, FiCalendar, FiTag,
  FiMessageSquare, FiSend, FiUser, FiHeadphones
} from 'react-icons/fi';
import axios from 'axios';
import { useTheme } from '../../../../contexts/ThemeContext';
import MyContext from '../../../../contexts/AppContext';
import SellerMasterLayout from '../../../../layouts/seller/SellerMasterLayout';
import '../../../../assets/css/seller/subscreens/support/ticketview/TicketView.css';
import '../../../../assets/css/seller/subscreens/support/ticketHeader/TicketHeader.css';
import '../../../../assets/css/seller/subscreens/support/ticketInfo/TicketInfo.css';
import '../../../../assets/css/seller/subscreens/support/ticketchat/TicketChat.css';

const TicketView = () => {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const { baseUrl, selectedSellerTicket ,sellerAuthToken} = useContext(MyContext);

  const ticket = selectedSellerTicket;
  const seller = JSON.parse(localStorage.getItem("loggedInSeller"));
  const sellerId = seller?.id;

  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  const fetchMessages = () => {
    axios
      .get(`${baseUrl}/seller/support/getMessages`, {
        params: { ticket_id: ticket?.id, seller_id: sellerId },
         headers: {
        Authorization: `Bearer ${sellerAuthToken}`,
      },
      })
      .then((res) => setChatMessages(res.data?.messages || []))
      .catch(() => {});
  };

  const handleSendMessage = () => {
    if (!newMessage.trim()) return;

    const formdata = new FormData();
    formdata.append('ticket_id', ticket?.id);
    formdata.append('seller_id', sellerId);
    formdata.append('message', newMessage);
    setNewMessage('');

    axios
      .post(`${baseUrl}/seller/support/sendMessage`, formdata, {
        headers: { 'Content-Type': 'multipart/form-data' ,
          Authorization: `Bearer ${sellerAuthToken}`,
        },
      })
      .then(() => fetchMessages())
      .catch(() => {});
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchMessages();
    const interval = setInterval(fetchMessages, 5000);
    return () => clearInterval(interval);
  }, [ticket?.id]);

  const getStatusClass = (status) => {
    const statusMap = {
      'In review': 'tv-status-processing',
      'In Progress': 'tv-status-processing',
      'Waiting your reply': 'tv-status-active',
      'Resolved': 'tv-status-resolved',
      'Closed': 'tv-status-closed'
    };
    return statusMap[status] || 'tv-status-processing';
  };

  if (!ticket) {
    return (
      <SellerMasterLayout>
        <div style={{ padding: '2rem', textAlign: 'center', color: '#999' }}>
          Ticket not found. <button onClick={() => navigate('/seller/support')} style={{ color: '#ff8559', background: 'none', border: 'none', cursor: 'pointer' }}>Go back</button>
        </div>
      </SellerMasterLayout>
    );
  }

  const isTicketClosed = ticket.status === 'Resolved' || ticket.status === 'Closed';

  return (
    <SellerMasterLayout>
      <div className={`sd-shell ${isDark ? 'dark-mode' : 'light-mode'}`}>
        <div className="ticket-view-wrapper">

          <button className="tv-back-btn" onClick={() => navigate('/seller/support')}>
            <FiArrowLeft /> Back to Support
          </button>

          <div className="tv-header">
            <div className="tv-header-left">
              <div className="tv-header-icon"><FiFileText /></div>
              <div>
                <h1 className="tv-header-id">#TCK-{ticket.id}</h1>
                <p className="tv-header-subject">{ticket.category}</p>
              </div>
            </div>
            <div className="tv-header-right">
              <div className="tv-header-badges">
                <span className={`tv-status-badge ${getStatusClass(ticket.status)}`}>
                  {ticket.status}
                </span>
              </div>
            </div>
          </div>

          <div className="tv-layout">
            <div className="tv-left">

              <div className="tv-card ticket-info-card">
                <h3 className="tv-card-title"><FiFileText /> Ticket Details</h3>
                <div className="ticket-info-grid">
                  <div className="ticket-info-item">
                    <div className="ticket-info-icon"><FiCalendar /></div>
                    <div>
                      <span className="ticket-info-label">Created</span>
                      <span className="ticket-info-value">
                        {new Date(ticket.created_at).toLocaleString('en-PK', {
                          day: 'numeric', month: 'short', year: 'numeric',
                          hour: '2-digit', minute: '2-digit'
                        })}
                      </span>
                    </div>
                  </div>
                  <div className="ticket-info-item">
                    <div className="ticket-info-icon"><FiClock /></div>
                    <div>
                      <span className="ticket-info-label">Last Updated</span>
                      <span className="ticket-info-value">
                        {new Date(ticket.updated_at).toLocaleString('en-PK', {
                          day: 'numeric', month: 'short', year: 'numeric',
                          hour: '2-digit', minute: '2-digit'
                        })}
                      </span>
                    </div>
                  </div>
                  <div className="ticket-info-item">
                    <div className="ticket-info-icon"><FiTag /></div>
                    <div>
                      <span className="ticket-info-label">Category</span>
                      <span className="ticket-info-value">{ticket.category}</span>
                    </div>
                  </div>
                </div>
                <div className="ticket-description">
                  <h4 className="ticket-description-title">Description</h4>
                  <p className="ticket-description-text">{ticket.description}</p>
                </div>
              </div>

            </div>

            <div className="tv-right">

              <div className="tv-card ticket-chat-card">
                <h3 className="tv-card-title"><FiMessageSquare /> Conversation</h3>
                <div className="ticket-chat-messages">
                  {chatMessages.map((msg) => (
                    <div key={msg.id} className={`ticket-chat-message ${msg.sender === 'chseller' ? 'seller' : 'support'}`}>
                      <div className="ticket-chat-avatar">
                        {msg.sender === 'chseller' ? <FiUser /> : <FiHeadphones />}
                      </div>
                      <div className="ticket-chat-bubble">
                        <div className="ticket-chat-header">
                          <span className="ticket-chat-sender">
                            {msg.sender === 'chseller' ? 'You' : 'Support Team'}
                          </span>
                          <span className="ticket-chat-time">
                            {new Date(msg.created_at).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </div>
                        <p className="ticket-chat-text">{msg.message}</p>
                      </div>
                    </div>
                  ))}
                </div>

                {isTicketClosed ? (
                  <div className="ticket-chat-closed">
                    <FiMessageSquare />
                    <span>This ticket is closed.</span>
                  </div>
                ) : (
                  <div className="ticket-chat-input-row">
                    <input
                      type="text"
                      className="ticket-chat-input"
                      placeholder="Type your message..."
                      value={newMessage}
                      onChange={(e) => setNewMessage(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                    <button className="ticket-chat-send-btn" onClick={handleSendMessage}>
                      <FiSend />
                    </button>
                  </div>
                )}
              </div>

            </div>
          </div>
        </div>
      </div>
    </SellerMasterLayout>
  );
};

export default TicketView;